var _mask, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColorfinderMapDefault = function SvgColorfinderMapDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "colorfinder-map-default_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#28282C",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#colorfinder-map-default_svg__a)",
    "data-figma-skip-parse": "true",
    mask: "url(#colorfinder-map-default_svg__b)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: 2166.67,
    height: 2166.67,
    x: -1083.33,
    y: -1083.33,
    transform: "rotate(90 0 12)scale(.012)"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,#eb5143 0deg,#f0f43c 121.815deg,#4c89e8 252.602deg,#eb5143 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12h-1c0 6.075-4.925 11-11 11v2c7.18 0 13-5.82 13-13zM12 24v-1C5.925 23 1 18.075 1 12h-2c0 7.18 5.82 13 13 13zM0 12h1C1 5.925 5.925 1 12 1v-2C4.82-1-1 4.82-1 12zM12 0v1c6.075 0 11 4.925 11 11h2c0-7.18-5.82-13-13-13z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.94354903697967529,\"g\":0.95750916004180908,\"b\":0.23624084889888763,\"a\":1.0},\"position\":0.33837437629699707},{\"color\":{\"r\":0.29841524362564087,\"g\":0.53851240873336792,\"b\":0.91340112686157227,\"a\":1.0},\"position\":0.70167320966720581},{\"color\":{\"r\":0.92161113023757935,\"g\":0.32063350081443787,\"b\":0.26318705081939697,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.94354903697967529,\"g\":0.95750916004180908,\"b\":0.23624084889888763,\"a\":1.0},\"position\":0.33837437629699707},{\"color\":{\"r\":0.29841524362564087,\"g\":0.53851240873336792,\"b\":0.91340112686157227,\"a\":1.0},\"position\":0.70167320966720581},{\"color\":{\"r\":0.92161113023757935,\"g\":0.32063350081443787,\"b\":0.26318705081939697,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":-6.9410225478350185e-06,\"m01\":-24.0,\"m02\":24.000005722045898,\"m10\":24.0,\"m11\":-6.9410220930876676e-06,\"m12\":2.4526991637685569e-06},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}",
    mask: "url(#colorfinder-map-default_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.44 7.046a5.39 5.39 0 0 1 7.417.193l.191.201a5.386 5.386 0 0 1 .256 6.907l3.448 3.448-.883.883-3.439-3.438a5.39 5.39 0 0 1-6.99-.192l-.201-.19a5.39 5.39 0 0 1 0-7.62zm6.533 1.077a4.137 4.137 0 1 0-5.851 5.85 4.137 4.137 0 0 0 5.851-5.85"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "colorfinder-map-default_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12h-1c0 6.075-4.925 11-11 11v2c7.18 0 13-5.82 13-13zM12 24v-1C5.925 23 1 18.075 1 12h-2c0 7.18 5.82 13 13 13zM0 12h1C1 5.925 5.925 1 12 1v-2C4.82-1-1 4.82-1 12zM12 0v1c6.075 0 11 4.925 11 11h2c0-7.18-5.82-13-13-13z",
    mask: "url(#colorfinder-map-default_svg__b)"
  })))));
};
export default SvgColorfinderMapDefault;